import { render, staticRenderFns } from "./UsageSection.vue?vue&type=template&id=1002c53a&scoped=true&"
import script from "./UsageSection.vue?vue&type=script&lang=js&"
export * from "./UsageSection.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/adminSection.css?vue&type=style&index=0&id=1002c53a&prod&scoped=true&lang=css&"
import style1 from "./UsageSection.vue?vue&type=style&index=1&id=1002c53a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1002c53a",
  null
  
)

export default component.exports